import { render, staticRenderFns } from "./livepicform.vue?vue&type=template&id=4b9e6769&scoped=true&"
import script from "./livepicform.vue?vue&type=script&lang=js&"
export * from "./livepicform.vue?vue&type=script&lang=js&"
import style0 from "./livepicform.vue?vue&type=style&index=0&id=4b9e6769&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e6769",
  null
  
)

export default component.exports